import { render, staticRenderFns } from "./EmployeeCreate.vue?vue&type=template&id=406aa5af"
import script from "./EmployeeCreate.vue?vue&type=script&lang=ts"
export * from "./EmployeeCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports